import getPageName from './getPageName';

// const citizenRequest = 'https://localhost:44328/CitizenRequest/NewInternationalCommerceRequest'; // debug
const citizenRequest =
  'https://2025.api.tgu-dpo.ru/citizenrequest/NewInternationalCommerceRequest';
const crmRequest = 'https://sigmaedu.ru/handler.php';

// Добавление disabled кнопки отправки формы
export function setFormCheckbox(arr, btn) {
  arr.forEach((item) => {
    item.addEventListener('change', function () {
      if (!arr.find((checkbox) => !checkbox.checked)) {
        btn.removeAttribute('disabled');
      } else {
        btn.setAttribute('disabled', 'disabled');
      }
    });
  });
}

// Установка формы
export function setForm(selector, phoneIti) {
  var form = document.querySelector(selector);

  if (!form) {
    return;
  }

  form.addEventListener('submit', function (e) {
    sendForm(form, e, phoneIti);
  });

  addMaxLengthPromocode(form);

  onFormFilling(form, () => {    
    ym(89966386, 'reachGoal', 'FormStart');
    VK.Goal('initiate_checkout');
    VK.Retargeting.Event('initiate_checkout');
    fbq('track', 'InitiateCheckout');

    if (form.id == "form-aiWebinar") {
      ym(89966386,'reachGoal','start_web');
    }

    if (getPageName() == 'webinar') {
      ym(89966386,'reachGoal','start_submit_webinar_wed');
    }

    //Mail.ru
    var _tmr = window._tmr || (window._tmr = []);
    _tmr.push({
      id: '3272381',
      type: 'reachGoal',
      goal: 'initiate_checkout',
    });
  });
}

/* Скачивание pdf файла при отправке основной формы */
function downloadPdf() {
  if (
    getPageName() === 'marketplaces' ||
    getPageName() === 'marketplacesbonus' ||
    getPageName() === 'marketplacebonus' ||
    getPageName() === 'marketplace' ||
    getPageName() === 'marketplaces-pro'
  ) {
    var link = document.createElement('a');
    link.setAttribute('href', '/files/marketplace_file.pdf');
    link.setAttribute('download', 'marketplace_file');
    link.click();
  } else if (getPageName() === 'dataanalyst') {
    var link = document.createElement('a');
    link.setAttribute('href', '/files/dataanalyst.pdf');
    link.setAttribute('download', 'dataanalyst');
    link.click();
  } else if (
    getPageName() === 'psycholog' ||
    getPageName() === 'psycholog-cons'
  ) {
    var link = document.createElement('a');
    link.setAttribute('href', '/files/psycholog.pdf');
    link.setAttribute('download', 'psycholog');
    link.click();
  } else if (getPageName() === 'onecprogrammer') {
    var link = document.createElement('a');
    link.setAttribute('href', '/files/onecprogrammer.pdf');
    link.setAttribute('download', 'onecprogrammer');
    link.click();
  } else if (
    getPageName() === 'foreigntradebonus' ||
    getPageName() === 'foreign-trade-china' ||
    getPageName() === 'trade-china'
  ) {
    var link = document.createElement('a');
    link.setAttribute('href', '/files/foreigntrade.pdf');
    link.setAttribute('download', 'foreigntrade');
    link.click();
  } else if (getPageName() === 'graphicdesigner') {
    var link = document.createElement('a');
    link.setAttribute('href', '/files/graphicdesigner.pdf');
    link.setAttribute('download', 'graphicdesigner');
    link.click();
  } 
  else if (getPageName() === 'nutritionist-pro') {
    var link = document.createElement('a');
    link.setAttribute('href', '/files/Top_10_products.pdf');
    link.setAttribute('download', 'Top_10_products');
    link.click();
  }
}

/* Спиннер */
function createLoader() {
  const loader = document.createElement('div');
  loader.classList.add('loader');
  loader.innerHTML = `
        <div class="loader-wrap">
            <div class="ball-spin-fade-loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            <p class="loader-text">Сейчас вы будете перенаправлены<br> на страницу оплаты</p>
        </div>
    `;

  document.body.append(loader);
}

function removeLoader() {
  const loader = document.querySelector('.loader');

  if (loader) {
    loader.remove();
  }
}

/* Добавление скрипта AdvCake на сайт */
function addAdvCakeScript(id, OdinId, program, email, RoistatCookie, Promocode) {
  const pageUrl = document.location.href;
  let advcakeCookie = getCookie('advcake_track_id');

  window.advcake_data = window.advcake_data || [];
  window.advcake_data.push({
    pageType: 6,
    user: {
      email: `md5(${email})`,
      type: '',
    },
    leadInfo: {
      id: `${id}`,
      leadid: `${OdinId}`,
      name: `${program}`,
      totalPrice: 0,
      coupon: `${Promocode != undefined ? Promocode : ''}`,
      marketing_cat: 3,
      RoistatCookie: `${RoistatCookie}`,
      trackId: `${advcakeCookie}`,
      url: `${pageUrl}`,
    },
  });
}

/* Инициализация поля телефона */
const listCountries = [
  'az',
  'am',
  'by',
  'kz',
  'kg',
  'md',
  'ru',
  'tj',
  'tm',
  'uz',
];

export class Phone {
  constructor(options) {
    this.$el = document.querySelector(options.id);
    this.iti = options.iti;
  }

  setupMaskPhone() {
    if (this.$el) {
      this.iti = window.intlTelInput(this.$el, {
        separateDialCode: true,
        preferredCountries: ['ru'],
        initialCountry: 'auto',
        geoIpLookup: function (callback) {
          fetch('https://ipapi.co/json')
            .then(function (res) {
              return res.json();
            })
            .then(function (data) {
              if (!listCountries.includes(data.country_code)) {
                callback('ru');
              } else {
                callback(data.country_code);
              }
            })
            .catch(function () {
              callback('ru');
            });
        },
        utilsScript: '/js/utils.js',
      });

      const setIntervalStartPlaceholder = setInterval(() => {
        let placeholderInputPhone = this.$el.placeholder;

        if (placeholderInputPhone != '') {
          let maskNumber = placeholderInputPhone.replace(/[0-9+]/gi, '9');

          $(this.$el).mask(maskNumber, { autoclear: false });

          clearInterval(setIntervalStartPlaceholder);
        }
      }, 500);

      this.$el.addEventListener('countrychange', function () {
        let placeholderInputPhone = document.getElementById(
          this.id
        ).placeholder;
        let maskNumber = placeholderInputPhone.replace(/[0-9+]/gi, '9');

        $('#' + this.id).mask(maskNumber, { autoclear: false });
      });
    }
  }
}

const phone = new Phone({
  iti: 'itiPhone',
  id: '#phone',
});
phone.setupMaskPhone();

const phoneSpecial = new Phone({
  iti: 'itiPhoneHome',
  id: '#phone-special',
});
phoneSpecial.setupMaskPhone();

const phonePDF = new Phone({
  iti: 'itiPhonePDF',
  id: '#phone-pdf',
});
phonePDF.setupMaskPhone();

let phoneSale = new Phone({
  iti: 'itiPhoneSale',
  id: '#phone-sale',
});
phoneSale.setupMaskPhone();

let phoneTake = new Phone({
  iti: 'itiPhoneTake',
  id: '#phone-take',
});
phoneTake.setupMaskPhone();

let phoneGetProgram = new Phone({
  iti: 'itiPhoneGetProgram',
  id: '#getProgram-phone',
});
phoneGetProgram.setupMaskPhone();

let phoneGetProgram_1 = new Phone({
  iti: 'itiPhoneGetProgram_1',
  id: '#getProgram-phone-1',
});
phoneGetProgram_1.setupMaskPhone();

// Получение cookie
function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

var validators = {
  requried: function (value, error) {
    if (!value || value.length === 0) {
      error.message = 'Это поле обязательно';
      return false;
    } else {
      return true;
    }
  },
  email: function (value, error) {
    if (/.+@.+\..+/.test(value)) {
      return true;
    } else {
      error.message = 'Некорректный email';
      return false;
    }
  },
  phone: function (status, error) {
    if (status) {
      return true;
    } else {
      error.message = 'Некорректный номер';
      return false;
    }
  },
  phoneTariffs: function (value, error) {
    let phone = value.replace(/\D/g, '');
        
    if (phone.length === 11) {
      return true;
    } else {
      error.message = 'Некорректный номер';
      return false;
    }
  },
};

// Показ ошибок при заполнении формы
function showError(error, field) {
  if (error.message) {
    var errorContainer = document.createElement('div');
    errorContainer.textContent = error.message;
    errorContainer.classList.add('form__error-container');
    field.appendChild(errorContainer);
  }
}

// Валидация формы
function validate(form, phoneIti) {
  var result = true;
  Array.from(form.querySelectorAll('.form__field')).forEach(function (
    formField
  ) {
    var error = {};
    var control = formField.querySelector('select, input, textarea');
    if (formField.querySelector('.form__required')) {
      if (!validators.requried(control.value, error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
        return;
      }
    }

    if (control.id === 'phone-tariffs--1' || control.id === 'phone-tariffs--2' || control.id === 'phone-tariffs--3') {
      if (!validators.phoneTariffs(control.value, error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
      }
    }

    if (control.id === 'phone') {
      if (!validators.phone(phone.iti.isValidNumber(), error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
      }
    }

    if (control.id === 'phone') {
      if (!validators.phone(phone.iti.isValidNumber(), error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
      }
    }

    if (control.id === 'phone-sale') {
      if (!validators.phone(phoneSale.iti.isValidNumber(), error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
      }
    }

    if (control.id === 'phone-pdf') {
      if (!validators.phone(phonePDF.iti.isValidNumber(), error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
      }
    }

    if (control.id === 'phone-special') {
      if (!validators.phone(phoneSpecial.iti.isValidNumber(), error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
      }
    }

    if (control.id === 'phone-modal') {
      if (!validators.phone(phoneIti.iti.isValidNumber(), error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
      }
    }

    if (
      control.id === 'email' ||
      control.id === 'email-sale' ||
      control.id === 'email-pdf' ||
      control.id === 'email-special'||
      control.id === 'getProgram-email'||
      control.id === 'getProgram-email-1'
    ) {
      if (!validators.email(control.value, error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
      }
    }

    let invalidField = form.querySelector('.form__field--invalid');
    if (invalidField) {
      invalidField.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  });
  return result;
}

// Удаление ошибок с формы
function deleteErrors(form) {
  form.querySelectorAll('.form__error-container').forEach(function (el) {
    el.remove();
  });
  form.querySelectorAll('.form__field--invalid').forEach(function (el) {
    el.classList.remove('form__field--invalid');
  });
}

function formSubmitCommerce(data) {
  let link = '';

  if (getPageName() == 'partners') {
    link = 'https://hook.eu2.make.com/16hdfk865z2dyowcfatj3emogrhf6vcc';
  } else if (getPageName() == 'ai-webinar' || getPageName() == 'ai-special-bonus') {
    link = 'https://hook.eu2.make.com/vln2wd02mb7bzssrf815i4sgrm1bm1zj';
  } else if (getPageName() == 'ai-special-offer') {
    link = 'https://hook.eu2.make.com/ik5w7srji13iic6tnywltdfw9jqw354e';
  } else if (getPageName() == 'webinar' || getPageName() == 'foreigntrade-pro') {
    link = 'https://hook.eu2.make.com/a70ffp1r86ckl6bewosfbr13og1xcn8r';
  } else if (getPageName() == 'ai-for-kids') {
    link = 'https://hook.eu2.make.com/etajylrd64jb0p3bk5hqj7d99rfb0m1i';
  } else {    
    link = crmRequest;
  }

  $.ajax({
    url:  link,
    method: 'POST',
    contentType: 'application/json;charset=utf-8',
    data: JSON.stringify(data),
    success: function () {},
    error: function () {},
  });
}

/* Получение данных с форм в модальных окнах */
function getFormModalData(formClass) {
  const forms = document.querySelectorAll(formClass);

  let data = {};
  [...forms].forEach((form) => {
    Array.from(new FormData(form)).forEach(function (formElement) {
      let key = formElement[0];
      let value = formElement[1];

      data[key] = value;
    });

    form.reset();
  });

  return data;
}

/* Переключение и отправка формы в Квизе */
function quizForm(phoneIti) {
  const slides = document.querySelectorAll('.quiz__slide'),
    submit = document.getElementById('quiz-btn');

  if (slides.length < 1) {
    return;
  }

  submit.addEventListener('click', (e) => {
    let target = e.target,
      form = target.closest('.quiz__slide-form');

    e.preventDefault();
    deleteErrors(form);

    if (validate(form)) {
      sendForm(form, e, phoneIti, getFormModalData('.quiz__slide-form'));
    }
  });
}

/* Модальное окно успешно отправленной формы */
function successModal() {
  let modal = document.querySelector('#quiz-success');
  if (!modal) {
    modal = document.createElement('div');
    ['modal'].forEach((additionalClass) => {
      modal.classList.add(additionalClass);
    });
    modal.id = 'quiz-success';
    modal.innerHTML = '<div class="quiz__content"></div>';

    document.body.append(modal);
  }

  const a = document.createElement('a');
  a.href = '#quiz-success';
  a.rel = 'modal:open';
  a.style.display = 'none';
  document.body.append(a);

  window.openSuccessModal = () => {
    modal.classList.add('rvr-modal');
    modal.classList.add('succes-quiz');
    setStyles(modal, {
      position: 'relative',
      paddingBottom: '2rem',
    });
    if (
      getPageName() == 'marketplace' ||
      getPageName() == 'marketplaces' ||
      getPageName() == 'marketplaces-pro'
    ) {
      modal.querySelector('.quiz__content').innerHTML = /*html*/ `
        <div class="marketplace">
          <h3>Благодарим, что оставили заявку, в&nbsp;ближайшее время менеджер свяжется с&nbsp;вами.</h3>
          <h4><b>На&nbsp;почту мы&nbsp;уже отправили подборку</b> с&nbsp;бесплатными&nbsp;материалами.</h4>
        </div>
      `;
    } else if (getPageName() == 'project-manager') {
      modal.querySelector('.quiz__content').innerHTML = /*html*/ `
        <div class="quiz__content-wrapper project-manager">
          <h3>Поздравляем, вы&nbsp;сделали первый шаг к&nbsp;карьере своей мечты!</h3>
          <p>Первый урок курса &laquo;Руководитель проектов&raquo; уже ждет вас по&nbsp;ссылке ниже 👇</p>
          <a href="https://youtu.be/lGIetXanAKQ?si=MGEMXJlXAUBSFSWy" target="_blank" rel="nofollow noopener noreferrer">Ссылка здесь</a>
          <p><i>Обязательно смотрите видео-урок, в&nbsp;котором вы&nbsp;узнаете основные задачи, функции руководителя проектов, а&nbsp;так&nbsp;же карьерные перспективы проектного менеджера.</i></p>
        </div>
      `;
    } else if (getPageName() == 'trade-china') {
      modal.querySelector('.quiz__content').innerHTML = /*html*/ `
        <div class="quiz__content-wrapper project-manager">
          <h3>Здравствуйте! На связи Академия Sigma!</h3>
          <p><b>Поздравляем, вы&nbsp;сделали первый шаг к&nbsp;карьере своей мечты!</b></p>
          <p>Первый урок курса «Специалист ВЭД: бизнес с Китаем» уже ждет вас по ссылке ниже 👇</p>
          <a href="https://vk.cc/cAkn35" target="_blank" rel="nofollow noopener noreferrer">Ссылка для просмотра</a>
          <p><i>Смотрите видео-урок и узнайте, какие основные задачи и функции специалиста по ВЭД, а также карьерные перспективы в сфере ВЭД.</i></p>
          <p><i>Приятного изучения!</i></p>
        </div>
      `;
    } else if (getPageName() == 'partners') {
      modal.querySelector('.quiz__content').innerHTML = /*html*/ `
        <div>
          <h3>Ваша заявка принята!</h3>
          <h4>Наш менеджер свяжется с&nbsp;вами с&nbsp;10&nbsp;до&nbsp;19&nbsp;мск. Звонок поступит с&nbsp;номера: +7 (495) 021-67-55.<br><br></h4>
          <div class="chat-bot chat-bot--alt">
            <a class="btn" href="https://t.me/sigma_ck_bot" target="_blank" rel="nofollow noopener noreferrer">Перейти в&nbsp;чат-бот</a>
            <p>Переходите в&nbsp;наш телеграм-бот Sigma&nbsp;Academy!</p>
          </div>
        </div>
      `;
    } else if (getPageName() == 'webinar') {
      modal.querySelector('.quiz__content').innerHTML = /*html*/ `
        <div>
          <h3>Ваша заявка принята!</h3>
          <h4>Дальнейшие инструкции о&nbsp;подключении к&nbsp;эфиру и&nbsp;вебинару будут направлены на&nbsp;указанные контактные данные. До встречи<br><br></h4>
          <div class="chat-bot chat-bot--alt">
            <a class="btn" href="https://t.me/Sigma_study_bot" target="_blank" rel="nofollow noopener noreferrer">Перейти в&nbsp;чат-бот</a>
            <p>Переходите в&nbsp;наш телеграм-бот Sigma&nbsp;Academy!</p>
          </div>
        </div>
      `;
    } else if (getPageName() == 'foreigntrade-pro') {
      modal.querySelector('.quiz__content').innerHTML = /*html*/ `
        <div>
          <h3>Ваша заявка принята!</h3>
          <h4>Наш менеджер свяжется с&nbsp;вами с&nbsp;9&nbsp;до&nbsp;17&nbsp;мск. Звонок поступит с&nbsp;номера: 8&nbsp;(495)&nbsp;324&#8209;34&#8209;26 или&nbsp;8&nbsp;(966)&nbsp;888&#8209;71&#8209;26.<br><br></h4>
          <div class="chat-bot chat-bot--alt">
            <a class="btn" href="https://t.me/ved_sigma" target="_blank" rel="nofollow noopener noreferrer">Перейти в&nbsp;Telegram</a>
            <p>Переходите в&nbsp;телеграм-канал ВЭД!</p>
          </div>
        </div>
      `;
    } else {
      modal.querySelector('.quiz__content').innerHTML = /*html*/ `
        <div>
          <h3>Ваша заявка принята!</h3>
          <h4>Наш менеджер свяжется с&nbsp;вами с&nbsp;9&nbsp;до&nbsp;17&nbsp;мск. Звонок поступит с&nbsp;номера: 8&nbsp;(495)&nbsp;324&#8209;34&#8209;26 или&nbsp;8&nbsp;(966)&nbsp;888&#8209;71&#8209;26.<br><br></h4>
          <div class="chat-bot chat-bot--alt">
            <a class="btn" href="https://t.me/Sigma_study_bot" target="_blank" rel="nofollow noopener noreferrer">Перейти в&nbsp;чат-бот</a>
            <p>Переходите в&nbsp;наш телеграм-бот Sigma&nbsp;Academy!</p>
          </div>
        </div>
      `;
    }
    a.click();
  };

  window.openSuccessModalCatalog = () => {
    modal.classList.add('rvr-modal');
    setStyles(modal, {
      position: 'relative',
      paddingBottom: '2rem',
    });
    modal.querySelector('.quiz__content').innerHTML = /*html*/ `
        <div>
          <h3 style="margin-bottom: 1rem">
              Благодарим за заявку!
          </h3>
          <p>Наш менеджер свяжется с вами в ближайшее время.</p>
        </div>
    `;
    a.click();
  };

  window.openSuccessModalPdf = () => {
    modal.classList.add('rvr-modal');
    setStyles(modal, {
      position: 'relative',
      paddingBottom: '2rem',
    });

    modal.querySelector('.quiz__content').innerHTML = /*html*/ `
                <h3 style="margin-bottom: 1rem">
                    Благодарим за заявку!
                </h3>
                <p>В ближайшее время Вам на почту придёт письмо с полной программой обучения</p>
              </div>
          `;
    a.click();

    const getPdf = document.createElement('a');
    document.body.appendChild(getPdf);

    switch (getPageName()) {
      case 'softwaretesting':
        getPdf.setAttribute(
          'download',
          'УТП Тестировщик программного обеспечения 144ч'
        );
        getPdf.setAttribute('href', '/files/trainingPDF/Softwaretesting.pdf');
        break;
      case 'marketplace':
        getPdf.setAttribute(
          'download',
          '15 полезных материалов для будущего менеджера маркетплейсов'
        );
        getPdf.setAttribute('href', '/files/trainingPDF/Marketplace.pdf');
        break;
      case 'smmtargetologist':
        getPdf.setAttribute('download', 'УТП Таргетолог и SMM-специалист 144ч');
        getPdf.setAttribute('href', '/files/trainingPDF/SmmTargetologist.pdf');
        break;
      case 'dataanalyst':
        getPdf.setAttribute('download', 'УТП_Аналитик данных_256 ч');
        getPdf.setAttribute('href', '/files/trainingPDF/Dataanalyst.pdf');
        break;
      case 'graphicdesign':
        getPdf.setAttribute(
          'download',
          'УТП Графический дизайн_ с нуля до первых проектов 256ч'
        );
        getPdf.setAttribute('href', '/files/trainingPDF/GraphicDesign.pdf');
        break;
      case 'graphicdesigner':
        getPdf.setAttribute(
          'download',
          'УТП Графический дизайн_ с нуля до первых проектов 256ч'
        );
        getPdf.setAttribute('href', '/files/trainingPDF/GraphicDesign.pdf');
        break;
      case 'webprogrammer':
        getPdf.setAttribute(
          'download',
          'УТП Web-программист - с нуля до первых проектов 144ч'
        );
        getPdf.setAttribute('href', '/files/trainingPDF/Webprogrammer.pdf');
        break;
      case 'psychologist':
        getPdf.setAttribute('download', 'УТП Психолог-консультант 256 ч');
        getPdf.setAttribute('href', '/files/trainingPDF/Psychologist.pdf');
        break;
      case 'psycholog':
        getPdf.setAttribute('download', 'УТП Психолог-консультант 256 ч');
        getPdf.setAttribute('href', '/files/trainingPDF/Psychologist.pdf');
        break;
      case 'accountant':
        getPdf.setAttribute(
          'download',
          'УТП_Бухгалтер_субъекта_малого_бизнеса_256 ч'
        );
        getPdf.setAttribute('href', '/files/trainingPDF/Accountant.pdf');
        break;
    }
    getPdf.click();
    document.body.removeChild(getPdf);
  };
}

/* Добавление стилей */
function setStyles(el, stylesObject) {
  if (!el) {
    return;
  }
  Object.keys(stylesObject).forEach((key) => {
    el.style[key] = stylesObject[key];
  });
}

/* Отслеживание заполнения формы */
function onFormFilling(form, callback) {
  const controls = form.querySelectorAll('input, select, textarea');
  let changed = false;
  controls.forEach((control) => {
    $(control).one('blur', (e) => {
      if (!changed) {
        callback(e);
        changed = true;
      }
    });
  });
}

// Максимальное число символов для поля "Промокод"
function addMaxLengthPromocode(form) {
  const promocode = form.querySelector('#promocode');
  if (promocode) {
    promocode.setAttribute('maxlength', '30');
  }
}

// Маска для телефона на тарифах
$("#phone-tariffs--1").mask("+7 (999) 999-99-99", { autoclear: false });
$("#phone-tariffs--2").mask("+7 (999) 999-99-99", { autoclear: false });
$("#phone-tariffs--3").mask("+7 (999) 999-99-99", { autoclear: false });
$("#phone-aiWebinar").mask("+7 (999) 999-99-99", { autoclear: false });
$("#phone-aiWebinar-AiSpecialBonus").mask("+7 (999) 999-99-99", { autoclear: false });

// Отправка формы
let firstFormData = {};

function sendForm(form, e, phoneIti, quizData = null) {
  var sendBtn = form.querySelector(
    'button[type="submit"], input[type="submit"]'
  );
  let data = {};

  if (quizData) {
    data = {...quizData};
  } else {
    e.preventDefault();
    deleteErrors(form);
    data = {};

    if (!validate(form, phoneIti)) {
      return;
    }

    Array.from(new FormData(form)).forEach(function (formElement) {
      var key = formElement[0];
      var value = formElement[1];
  
      if (key == 'Phone') {
        if (form.id === 'form-sale') {
          data[key] = phoneSale.iti.getNumber();
        } else if (form.id === 'form-pdf') {
          data[key] = phonePDF.iti.getNumber();
        } else if (form.id === 'form-special') {
          data[key] = phoneSpecial.iti.getNumber();
        } else if (form.id === 'form-modal') {
          data[key] = phoneIti.iti.getNumber();
        } else if (form.id === 'form-special-take') {
          data[key] = phoneTake.iti.getNumber();
        }else if (form.id === 'getProgram-form') {
          data[key] = phoneGetProgram.iti.getNumber();
        }else if (form.id === 'getProgram-form-1') {
          data[key] = phoneGetProgram_1.iti.getNumber();
        } else if (form.id === "form-tariffs--1" || form.id === "form-tariffs--2" || form.id === "form-tariffs--3" || form.id === "form-aiWebinar" || form.id === 'form-aiWebinar-AiSpecialBonus') {
          data[key] = value;
        } else {
          data[key] = phone.iti.getNumber();
        }
      } else {
        data[key] = value;
      }
    });
  }

  var url = document.location.href;

  var paramsStartIndex = url.indexOf('?');
  if (paramsStartIndex > -1) {
    url
      .slice(paramsStartIndex + 1, url.length)
      .split('&')
      .map(function (utmString) {
        return utmString.split('=');
      })
      .forEach(function (utmMark) {
        var key = utmMark[0];
        key = key[0].toUpperCase() + key.slice(1, key.length);
        var value = utmMark[1];
        value =
          value.indexOf('#') > -1 ? value.slice(0, value.indexOf('#')) : value;
        data[key] = value;
      });
  }

  // Roistat
  let roistatCookie = getCookie('roistat_visit');

  if (!!roistatCookie) {
    data['RoistatCookie'] = roistatCookie;
  }

  // Yclid
  let Yclid = getCookie('yclid');

  if (!!Yclid) {
    data['Yclid'] = Yclid;
  }

  // Url landing
  data['Landing'] = url.split('?')[0] || url;

  // Временный костыль для отправки формы
  data['Place'] = '';

  /* Если выбрана оплата Рассрочкой, то передаем значение длительности рассрочки в поле Block */
  if (data['Block'] == 'installment') {
    if (data['InstallmentDuration'] != undefined) {
      data['Block'] = data['InstallmentDuration'];
    }
  }

  if (form.id == 'form-special' || form.id == 'form-first') {
    firstFormData = { ...data };
  }

  if (form.id == 'quiz-form') {
    data['Program'] = firstFormData.Program;
    data['FirstName'] = firstFormData.FirstName;
    data['LastName'] = firstFormData.LastName;
    data['Email'] = firstFormData.Email;
    data['Phone'] = firstFormData.Phone;
    data['Block'] = firstFormData.Block;
    data['Promocode'] = firstFormData.Promocode;
    data['Place'] = firstFormData.Place;
  }

  /* Если есть проверочное поле капчи, передаем булевое значение */
  if (data['CheckCapcha'] && data['CheckCapcha'] == 'true') {
    data['CheckCapcha'] = true;
  }

  toastr.options.progressBar = true;

  $.ajax({
    url: citizenRequest,
    method: 'POST',
    contentType: 'application/json;charset=utf-8',
    data: JSON.stringify(data),

    success: function (result) {
      addAdvCakeScript(
        result.requestId,
        result.odinId,
        result.programName,
        data.Email,
        data.RoistatCookie,
        data.Promocode
      );

      sendBtn.disabled = false;
      VK.Goal('lead');
      VK.Retargeting.Event('lead');
      fbq('track', 'Lead');

      //Mail.ru
      var _tmr = window._tmr || (window._tmr = []);
      _tmr.push({ id: '3272381', type: 'reachGoal', goal: 'lead' });

      toastr.success('Анкета успешно отправлена', 'Успех!');
      form.reset();

      if (form.id == 'form-pdf') {
        ym(89966386, 'reachGoal', 'FormSubmitAndGetPDF');
      } else {        
        ym(89966386, 'reachGoal', 'FormSubmit');
      }

      if (form.id == 'quiz-form') {
        const quizSlides = document.querySelectorAll('.quiz__slide');
        quizSlides[quizSlides.length - 2].style.display = 'none';
        quizSlides[quizSlides.length - 1].style.display = 'flex';
      } else if (getPageName() == 'webinar') {    
        ym(89966386,'reachGoal','submit_webinar_wed');    
        openSuccessModal();   
      } else if (form.id == 'form-first') {
        // Открытие квиза
        if (document.querySelector('.quiz')) {
          document.querySelector('.quiz').classList.add('is-active');
          document.querySelector('body').classList.add('scroll-lock');          
        }
      } else if (form.id === 'form-pdf') {
        openSuccessModalPdf();
      } else if (form.id === 'form-aiWebinar' || form.id === 'form-aiWebinar-AiSpecialBonus') {
        ym(89966386,'reachGoal','submit_web');
        
        const button = document.createElement('button');
        button.setAttribute('data-modal-open', '');
        button.setAttribute('data-modal-id', 'aiWebinar-modal');
        button.style.display = 'none';
        document.body.append(button);
        button.click();
        button.remove();
      } else if (
        form.id === 'form-special' &&
        data['Program'] === 'Руководитель проектов'
      ) {
        openSuccessModal();
      } else if (form.id === 'form-special' && getPageName() === 'foreigntradebonus') {
        if (document.querySelector('.quiz')) {
          document.querySelector('.quiz').classList.add('is-active');
          document.querySelector('body').classList.add('scroll-lock');          
        }
      } else if ((data['Program'] === 'Специалист ВЭД: бизнес с Китаем') || data['Program'] === 'Нутрициолог: здоровье через питание') {
        if (getPageName() !== 'foreigntrade-pro') {
          $.ajax({
            url: crmRequest,
            method: 'POST',
            contentType: 'application/json;charset=utf-8',
            data: JSON.stringify(data),
            success: function () {
              window.location.assign("/thanks");
            },
            error: function () {
              toastr.error(
                'Пожалуйста, проверьте ваше соединение с сетью или повторите попытку позже',
                'Произошла ошибка!'
              );
            },
          });
        } else {
          openSuccessModal();
        }
      } else if (
        form.id === 'form-catalog' ||
        form.id === 'form-modal' ||
        form.id === 'form-special'
      ) {
        openSuccessModalCatalog();
      } else {
        openSuccessModal();        
      }

      /* Отправка в АМО */
      formSubmitCommerce(data);

      if(form.id === 'getProgram-form'){
        var link = document.createElement('a');
        link.setAttribute('href', '/files/Foreigntradebonus_program.pdf');
        link.setAttribute('download', 'Foreigntradebonus_program');
        link.click();
      }

      if (form.id === 'form-app') {
        downloadPdf();

        if (
          window.location.pathname === '/program/marketplaces' ||
          window.location.pathname === '/program/marketplacebonus' ||
          window.location.pathname === '/program/marketplacesbonus' ||
          window.location.pathname === '/program/marketplace' ||
          window.location.pathname === '/program/pro-marketplaces'
        ) {
          ym(89966386, 'reachGoal', 'FormSubmitAndGetPDF');
        }
      }

      /* Скрываем сообщение об ошибки капчи */
      if (data.CheckCapcha) {
        form.querySelector('.smart-captcha--error').style.display = 'none';
      }
    },
    error: function (error) {
      /* Если капча не заполнена или любая другая ошибка по ней, выводим сообщение */
      if (error.status == 403 && data.CheckCapcha) {
        form.querySelector('.smart-captcha--error').style.display = 'block';
      } else {
        toastr.error(
          'Пожалуйста, проверьте ваше соединение с сетью или повторите попытку позже',
          'Произошла ошибка!'
        );
      }

      sendBtn.disabled = false;
    },
  });
}

const form = () => {
  /* Список доступных тарифов для программ */
  const tariffsPrograms = {
    webprogrammer: {
      Middle: '144 часа',
    },
    psychologist: {
      Pro: '256 часов',
    },
    psycholog: {
      Pro: '256 часов',
    },
    marketplace: {
      Middle: '144 часа',
    },
    marketplaces: {
      Middle: '144 часа',
    },
    marketplacebonus: {
      Middle: '144 часа',
    },
    marketplacesbonus: {
      Middle: '144 часа',
    },
    softwaretesting: {
      Middle: '144 часа',
    },
    graphicdesign: {
      Pro: '256 часов',
    },
    graphicdesigner: {
      Pro: '256 часов',
    },
    'data-analysis': {
      Pro: '256 часов',
    },
    accountant: {
      Pro: '256 часов',
    },
    uidesign: {
      Middle: '144 часа',
    },
    smmtargetologist: {
      Middle: '144 часа',
    },
    onecprogr: {
      Middle: '144 часа',
    },
    onecprogrammer: {
      Middle: '144 часа',
    },
    rykovodproject: {
      Junior: '72 часа',
    },
    'project-manager': {
      Junior: '72 часа',
    },
    foreigntradebonus: {
      Middle: '144 часа',
    },
    'foreign-trade-china': {
      Middle: '144 часа',
    },
    'trade-china': {
      Middle: '144 часа',
    },
    'psycholog-cons': {
      Pro: '256 часов',
    },
    nutritionist: {
      Pro: '256 часов',
    },
    'marketplaces-pro': {
      Middle: '144 часа',
    },
    'pro-marketplaces': {
      Middle: '144 часа',
    },
    foreigntrade: {
      Middle: 'ВЭД',
      Pro: 'ВЭД + ВЭД PRO',
    },
    foreigntradepro: {
      Middle: 'ВЭД PRO',
      Pro: 'ВЭД + ВЭД PRO',
    },
    "ai-special-offer": {
      Junior: 'Базовый',
      Middle: 'Продвинутый',
      Pro: 'Эксперт',
    },
    "ai-special-bonus": {
      Junior: 'Базовый',
      Middle: 'Продвинутый',
      Pro: 'Эксперт',
    }
  };

  /* Поиск доступных тарифов */
  function searchTariffs() {
    const Programs = document.getElementById('ProgramForm'),
      Tariffs = document.getElementById('TariffForm'),
      Tariffs_Bonus = document.getElementById('TariffForm-AiSpecialBonus'),
      url = document.location.href;

    if (Programs) {
      Programs.onchange = (e) => {
        if (Programs.selectedIndex != '-1') {
          let program =
            Programs.options[Programs.selectedIndex].getAttribute('program');

          try {
            Tariffs.removeAttribute('disabled');
            createOptionsTariffs(tariffsPrograms[program]);
          } catch (e) {
            console.log(e);
          }
        }

        // в зависимости от выбранной программы подставляется нужная политика и оферта
        returnDocumentProgram(e.target.value);
      };
    } else if (url.includes('program')) {
      const pageName = getPageName();

      for (let key in tariffsPrograms) {
        if (key == pageName) {
          createOptionsTariffs(tariffsPrograms[pageName]);
          Tariffs && setPrices(tariffsPrograms[pageName]);
        }
      }
    } else if (getPageName() === "ai-special-offer" || getPageName() === "ai-special-bonus") {
      const pageName = getPageName();

      for (let key in tariffsPrograms) {
        if (key === pageName) {
          createOptionsTariffs(tariffsPrograms[pageName]);
        }
      }
    }

    /* Создание option для поля Тарифы */
    function createOptionsTariffs(obj) {
      if (Tariffs) {
        [...Tariffs.children].map((item, idx) => {
          if (idx > 0) {
            item.remove();
          }
        });
        
        for (let key in obj) {
          let option = new Option(obj[key], key, false, false);

          Tariffs.append(option);
        }
      }

      if (getPageName() === "ai-special-bonus") {
        if (Tariffs_Bonus) {
          [...Tariffs_Bonus.children].map((item, idx) => {
            if (idx > 0) {
              item.remove();
            }
          });
          
          for (let key in obj) {
            let option = new Option(obj[key], key, false, false);
  
            Tariffs_Bonus.append(option);
          }
        }
      }
    }
  }

  /* Подстановка цен в левую часть формы программ, в зависимости от длительности программы */
  function setPrices(data) {
    let formPrice = document.querySelector('.form__price').children,
      formDuration = document.querySelector('.form-left-duration');

    if (Object.values(data).join() == '144 часа') {
      formDuration.textContent = '2';
      if (
        getPageName() == 'marketplace' ||
        getPageName() == 'marketplaces' ||
        getPageName() == 'marketplacebonus' ||
        getPageName() == 'marketplaces-pro' ||
        getPageName() == 'pro-marketplaces' ||
        getPageName() == 'marketplacesbonus'
      ) {
        formPrice[0].getElementsByTagName('dd')[0].innerHTML =
          '95&nbsp;900&nbsp;руб.';
        formPrice[1].getElementsByTagName('dd')[0].innerHTML =
          '47&nbsp;950&nbsp;руб.';
        formPrice[2].getElementsByTagName('dd')[0].innerHTML =
          '1&nbsp;998&nbsp;руб.';
        return;
      } else if (
        getPageName() == 'foreigntrade' ||
        getPageName() == 'foreign-trade-china' ||
        getPageName() == 'uidesign' ||
        getPageName() == 'trade-china'
      ) {
        formPrice[0].getElementsByTagName('dd')[0].innerHTML =
          '89&nbsp;972&nbsp;руб.';
        formPrice[1].getElementsByTagName('dd')[0].innerHTML =
          '44&nbsp;986&nbsp;руб.';
        formPrice[2].getElementsByTagName('dd')[0].innerHTML =
          '1&nbsp;874&nbsp;руб.';
      } else if (
        getPageName() == 'onecprogr' ||
        getPageName() == 'onecprogrammer' ||
        getPageName() == 'webprogrammer' ||
        getPageName() == 'softwaretesting' ||
        getPageName() == 'smmtargetologist'
      ) {
        formPrice[0].getElementsByTagName('dd')[0].innerHTML =
          '89&nbsp;972&nbsp;руб.';
        formPrice[1].getElementsByTagName('dd')[0].innerHTML =
          '44&nbsp;986&nbsp;руб.';
        formPrice[2].getElementsByTagName('dd')[0].innerHTML =
          '1&nbsp;874&nbsp;руб.';
      } else if (getPageName() == 'foreigntradebonus') {
        formPrice[0].getElementsByTagName('dd')[0].innerHTML =
          '44&nbsp;986&nbsp;руб.';
      } else {
        formPrice[0].getElementsByTagName('dd')[0].innerHTML =
          '74&nbsp;975&nbsp;руб.';
        formPrice[1].getElementsByTagName('dd')[0].innerHTML =
          '37&nbsp;488&nbsp;руб.';
        formPrice[2].getElementsByTagName('dd')[0].innerHTML =
          '1&nbsp;562&nbsp;руб.';
      }
    } else {
      if (
        getPageName() == 'graphicdesign' ||
        getPageName() == 'graphicdesigner'
      ) {
        formPrice[0].getElementsByTagName('dd')[0].innerHTML =
          '149&nbsp;972&nbsp;руб.';
        formPrice[1].getElementsByTagName('dd')[0].innerHTML =
          '74&nbsp;986&nbsp;руб.';
        formPrice[2].getElementsByTagName('dd')[0].innerHTML =
          '3&nbsp;124&nbsp;руб.';
      }
    }
  }

  // Установка масок
  function setMasks() {
    $('#phone').mask('+7 (999) 999-99-99', { autoclear: false });
    $('#phone-sale').mask('+7 (999) 999-99-99', { autoclear: false });
    $('#phone-pdf').mask('+7 (999) 999-99-99', { autoclear: false });
    $('#phone-modal').mask('+7 (999) 999-99-99', { autoclear: false });
  }

  if (getPageName() !== 'thank-you') {
    $(function (phoneIti) {
      setMasks();
      setForm('#form-sale');
      setForm('#form-app');
      setForm('#form-questionnaire');
      setForm('#form-catalog');
      setForm('#form-pdf');
      setForm('#form-special');
      setForm('#form-special-take');
      setForm('#getProgram-form');
      setForm('#getProgram-form-1');
      setForm('#form-tariffs--1');
      setForm('#form-tariffs--2');
      setForm('#form-tariffs--3');
      setForm('#form-aiWebinar');
      setForm('#form-aiWebinar-AiSpecialBonus');
      setForm('#form-first');
      quizForm(phoneIti);
      addFormModalPartners();
      searchTariffs();

      if (
        document.querySelector('#personal-getProgram') 
      ) {
        setFormCheckbox(
          [
            document.querySelector('#personal-getProgram') 
          ],
          document.querySelector('#submit-getProgram')
        );
      }

      if (
        document.querySelector('#personal-getProgram-1') 
      ) {
        setFormCheckbox(
          [
            document.querySelector('#personal-getProgram-1') 
          ],
          document.querySelector('#submit-getProgram-1')
        );
      }

      if (
        document.querySelector('#personal-policy') &&
        document.querySelector('#personal-agreement')
      ) {
        setFormCheckbox(
          [
            document.querySelector('#personal-policy'),
            document.querySelector('#personal-agreement'),
          ],
          document.querySelector('#submit-form')
        );
      }

      if (
        document.querySelector('#personal-policy-questionnaire') &&
        document.querySelector('#personal-agreement-questionnaire')
      ) {
        setFormCheckbox(
          [
            document.querySelector('#personal-policy-questionnaire'),
            document.querySelector('#personal-agreement-questionnaire'),
          ],
          document.querySelector('#submit-form-questionnaire')
        );
      }

      if (
        document.querySelector('#personal-data-sale') &&
        document.querySelector('#personal-oferta-sale')
      ) {
        setFormCheckbox(
          [
            document.querySelector('#personal-data-sale'),
            document.querySelector('#personal-oferta-sale'),
          ],
          document.querySelector('#submit-sale')
        );
      }

      if (document.querySelector('#personal-data-pdf')) {
        setFormCheckbox(
          [document.querySelector('#personal-data-pdf')],
          document.querySelector('#submit-pdf')
        );
      }

      if (document.querySelector('#personal-data-mailing')) {
        setFormCheckbox(
          [document.querySelector('#personal-data-mailing')],
          document.querySelector('#submitFormMailing')
        );
      }

      if (document.querySelector('#aiWebinar-agreement')) {
        setFormCheckbox(
          [document.querySelector('#aiWebinar-agreement')],
          document.querySelector('#submit-form')
        );
      }

      if (
        document.querySelector('#aiWebinar-agreement') &&
        document.querySelector('#aiWebinar-oferta')
      ) {
        setFormCheckbox(
          [
            document.querySelector('#aiWebinar-agreement'),
            document.querySelector('#aiWebinar-oferta'),
          ],
          document.querySelector('#submit-form')
        );
      }

      if (
        document.querySelector('#aiWebinar-agreement-AiSpecialBonus') &&
        document.querySelector('#aiWebinar-oferta-AiSpecialBonus')
      ) {
        setFormCheckbox(
          [
            document.querySelector('#aiWebinar-agreement-AiSpecialBonus'),
            document.querySelector('#aiWebinar-oferta-AiSpecialBonus'),
          ],
          document.querySelector('#submit-form-AiSpecialBonus')
        );
      }
    });
  }

  /* Инициализация селектов */
  function setSelects() {
    const selectors = [
      {
        id: '#ProgramForm',
        placeholder: 'Программа обучения',
      },
      {
        id: '#DirectionForm',
        placeholder: 'Направление',
      },
      {
        id: '#TariffForm',
        placeholder: 'Тариф',
      },
      {
        id: '#TariffForm-AiSpecialBonus',
        placeholder: 'Тариф',
      },
      {
        id: '#PayForm',
        placeholder: 'Выберите услугу',
      },
      {
        id: '#GoalStudy',
        placeholder: 'Цель обучения',
      },
      {
        id: '#MonthlyIncome',
        placeholder: 'Доход',
      },
      {
        id: '#LevelOfEducation',
        placeholder: 'Образование',
      },
      {
        id: '#Age',
        placeholder: 'Возраст',
      },
      {
        id: '#AvailabilityDevices',
        placeholder: 'Техника для учебы',
      },
      {
        id: '#TimeToStudy',
        placeholder: 'Время для учебы',
      },
    ];

    selectors.forEach((item) => {
      let selector = $(item.id),
        message = '';

      selector.select2({
        placeholder: item.placeholder,
        language: {
          noResults: function () {
            return message;
          },
        },
        escapeMarkup: function (markup) {
          return markup;
        },
      });

      selector.val(null).trigger('change');
    });
  }

  /* Select2 */
  $(document).ready(function () {
    /* ВК метрика: более 30 сек на сайте */
    setTimeout(() => {
      VK.Retargeting.Event('PageView30sec');
    }, 30000);

    /* ВК метрика: более 60 сек на сайте */
    setTimeout(() => {
      VK.Retargeting.Event('PageView60sec');
    }, 60000);

    successModal();
    setSelects();
  });

  function returnDocumentProgram(program) {
    const form__politics = document.querySelectorAll('.form__politics'),
      form__oferta = document.querySelectorAll('.form__oferta'),
      footer__politics = document.querySelector('.footer__politics'),
      footer__oferta = document.querySelector('.footer__oferta'),
      programs = {
        'Психолог-консультант: с нуля до первого клиента': {
          politics:
            '/files/NEWSTEP/Politika konfidencialnosti OOO UC Novyi Shag.pdf',
          oferta: '/files/NEWSTEP/Oferta OOO UC Novyi Shag.pdf',
        },
        'Тестировщик программного обеспечения': {
          politics:
            '/files/ANODPOUCPO/Politika konfidencialnosti ANO DPO UCPO.pdf',
          oferta: '/files/ANODPOUCPO/Oferta ANO DPO UCPO.pdf',
        },
        'Специалист по работе на маркетплейсах': {
          politics:
            '/files/ANODPOCMI/Politika konfidencialnosti ANO DPO CMI.pdf',
          oferta: '/files/ANODPOCMI/Oferta ANO DPO CMI.pdf',
        },
        '1С программист': {
          politics:
            '/files/ANODPOCMI/Politika konfidencialnosti ANO DPO CMI.pdf',
          oferta: '/files/ANODPOCMI/Oferta ANO DPO CMI.pdf',
        },
        'Аналитик данных: с нуля до разработки прикладных решений для бизнеса':
          {
            politics:
              '/files/NEWSTEP/Politika konfidencialnosti OOO UC Novyi Shag.pdf',
            oferta: '/files/NEWSTEP/Oferta OOO UC Novyi Shag.pdf',
          },
        'Web-программист: с нуля до первых проектов': {
          politics:
            '/files/ANODPOUCPO/Politika konfidencialnosti ANO DPO UCPO.pdf',
          oferta: '/files/ANODPOUCPO/Oferta ANO DPO UCPO.pdf',
        },
        'Бухгалтер субъекта малого бизнеса': {
          politics:
            '/files/NEWSTEP/Politika konfidencialnosti OOO UC Novyi Shag.pdf',
          oferta: '/files/NEWSTEP/Oferta OOO UC Novyi Shag.pdf',
        },
        'Графический дизайн: с нуля до первых проектов': {
          politics:
            '/files/ANODPOUCPO/Politika konfidencialnosti ANO DPO UCPO.pdf',
          oferta: '/files/ANODPOUCPO/Oferta ANO DPO UCPO.pdf',
        },
        'UI-дизайнер: практические навыки дизайнера интерфейсов': {
          politics:
            '/files/ANODPOCMI/Politika konfidencialnosti ANO DPO CMI.pdf',
          oferta: '/files/ANODPOCMI/Oferta ANO DPO CMI.pdf',
        },
        'Таргетолог и SMM-специалист': {
          politics:
            '/files/ANODPOUCPO/Politika konfidencialnosti ANO DPO UCPO.pdf',
          oferta: '/files/ANODPOUCPO/Oferta ANO DPO UCPO.pdf',
        },
      };

    for (let item in programs) {
      if (item == program) {
        for (let i = 0; i < form__politics.length; i++) {
          form__politics[i].href = programs[item].politics;
          form__oferta[i].href = programs[item].oferta;
        }

        footer__politics.href = programs[item].politics;
        footer__oferta.href = programs[item].oferta;
      }
    }
  }

  /* Для сайта Партнеров добавление формы в модальные окна */
  function addFormModalPartners() {
    const openModal = document.querySelectorAll('.teach_card'),
      modalPartners = document.querySelectorAll('.teach-modal .partners-modal');

    openModal.forEach((item, i) => {
      item.addEventListener('click', () => {
        for (let j = 0; j < modalPartners.length; j++) {
          modalPartners[j].innerHTML = '';
        }

        modalPartners[i].innerHTML = `
          <form id="form-sale">
            <div class="form-group">
                <div class="form__field">
                    <input type="tel" id="phone-sale" name="Phone" class="form__input">
                        <span class="form__required"></span>
                </div>
                <div class="form__field">
                    <input class="form__input" type="text" name="FirstName" id="name" placeholder="Имя"
                        maxlength="250">
                    <span class="form__required"></span>
                </div>
                <input type="hidden" value="-" name="LastName">
                <div class="form__field">
                    <input class="form__input" type="email" name="Email" id="email" placeholder="Email">
                    <span class="form__required"></span>
                </div>
                <div class="form__field">
                    <input class="form__input" type="text" name="Company" id="company"
                        placeholder="Компания">
                        <span class="form__required"></span>
                </div>
                <div class="form__field">
                    <input class="form__input" type="text" name="Comment" id="comment"
                        placeholder="Комментарий">
                </div>
                <div class="form__fields">
                  <div class="form__checkbox">
                    <input class="custom-checkbox" checked type="checkbox" class="agreement" id="personal-policy-sale">
                    <label class="form__label-check" for="personal-policy">
                      Нажимая кнопку &laquo;Отправить&raquo;, я&nbsp;соглашаюсь с&nbsp;условиями <a href="/files/oferta_file.pdf" class="form__oferta" target="blank" rel="noopener noreferrer"><span>публичной оферты</span></a> и <a href="/files/privacy_policy.pdf" class="form__politics" target="blank" rel="noopener noreferrer"><span>политики обработки персональных данных </span></a>
                    </label>
                  </div>
                  <div class="form__checkbox">
                    <input class="custom-checkbox" checked type="checkbox" class="agreement" id="personal-agreement-sale">
                    <label class="form__label-check" for="personal-agreement">
                      Я даю <a href="/files/agreement.pdf" target="blank" rel="noopener noreferrer"><span>согласие на обработку персональных данных</span></a>
                    </label>
                  </div>
                  <button type="submit" class="btn form__btn" id="submit-sale">Отправить</button>
                </div>
            </div>
        </form>
        `;

        phoneSale = new Phone({
          iti: 'itiPhoneSale',
          id: '#phone-sale',
        });
        phoneSale.setupMaskPhone();

        setFormCheckbox(
          [
            document.querySelector('#personal-policy-sale'),
            document.querySelector('#personal-agreement-sale'),
          ],
          document.querySelector('#submit-sale')
        );

        setForm('#form-sale');
      });
    });
  }

  // Функционал добавления поля длительности рассрочки
  (() => {
    const tariffMethods = document.querySelector('.tariffs__modal-methods');
    if (!tariffMethods) return;

    const durationSelectWrapper = document.querySelector(
      '[data-installment-duration]'
    );
    const validatorSpan =
      durationSelectWrapper.querySelector('.form__validator');
    let durationSelect = $('#InstallmentDuration');

    tariffMethods.addEventListener('click', (evt) => {
      if (evt.target.closest('[data-installment]')) {
        durationSelectWrapper.style.display = null;
        durationSelect.select2({
          placeholder: 'Длительность рассрочки',
        });
        durationSelect.val(null).trigger('change');
        validatorSpan.classList.add('form__required');
      } else {
        durationSelectWrapper.style.display = 'none';
        durationSelect.val(null);
        validatorSpan.classList.remove('form__required');
      }
    });
  })();

  /* Добавление поля длительности рассрочки на основных сайтах */
  (() => {
    const selectPayForm = document.getElementById('PayForm');

    if (!selectPayForm) return;

    const durationSelectWrapper = document.querySelector(
      '[data-installment-duration]'
    );
    const validatorSpan =
      durationSelectWrapper.querySelector('.form__validator');
    let durationSelect = $('#InstallmentDuration');

    selectPayForm.onchange = function (e) {
      let value = e.target.value;

      if (value == 'installment') {
        durationSelectWrapper.style.display = null;
        durationSelect.select2({
          placeholder: 'Длительность рассрочки',
        });
        durationSelect.val(null).trigger('change');
        validatorSpan.classList.add('form__required');
      } else {
        durationSelectWrapper.style.display = 'none';
        durationSelect.val(null);
        validatorSpan.classList.remove('form__required');
      }
    };
  })();

  /* Метрика на отправку формы в блоке formMailing */
  (() => {
    const submit = document.getElementById('submitFormMailing'),
      input = document.getElementById('inputFormMailing');

    if (!submit) return;

    submit?.addEventListener('click', () => {
      if (input.value != '') {
        ym(89966386, 'reachGoal', 'Subscription');
      }
    });
  })();
};

export default form;
